<template>
  <a-row :gutter="10" style="margin-top: 10px">
    <a-form :layout="formLayout" labelAlign="left" :form="searchForm" @submit="handleSubmit">
      <a-col :span="8">
        <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-radio-group
              v-decorator="['status']"
              :default-value="-1"
              button-style="solid"
              @change="onSetStatus"
          >
            <a-radio-button :value="-1">
              全部
            </a-radio-button>
            <a-radio-button :value="0">
              待审核
            </a-radio-button>
            <a-radio-button :value="1">
              审核通过
            </a-radio-button>
            <a-radio-button :value="2">
              审核驳回
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="提交时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-range-picker
              format="YYYY-MM-DD"
              v-decorator="['create_time']"
          />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-button style="margin-right: 10px" type="primary" html-type="submit" icon="search">搜索</a-button>
          <a-button @click="handleReset">重置表单</a-button>
        </a-form-item>
      </a-col>
    </a-form>
  </a-row>
</template>
<script>
import {SelectRegion} from '@/components'

export default {
  name: 'searchForm',
  components: {
    SelectRegion
  },
  data() {
    return {
      searchForm: this.$form.createForm(this),
      queryParam: {},
      formLayout: 'horizontal',
      labelCol: {
        style: 'width: 70px;float:left;margin-right:10px;white-space: nowrap;\n' +
            'text-overflow: ellipsis;\n' +
            '-o-text-overflow: ellipsis;\n' +
            'overflow: hidden;'
      },
      wrapperCol: {style: 'width: calc( 95% - 70px );float:left'},
    }
  },
  methods: {
    onSetStatus(e){
      this.searchForm.setFieldsValue({status:e.target.value})
      this.handleRefresh()
    },
    handleRefresh() {
      this.$emit('handleSubmit', this.searchForm.getFieldsValue())
    },

    handleSubmit(e) {
      e.preventDefault()
      const {searchForm: {validateFields}} = this
      validateFields((errors, values) => {
        if (errors) {
          return false
        }
        this.$emit('handleSubmit', values)
      })
    },
    handleReset() {
      this.searchForm.resetFields()
    }
  }
}
</script>
<style scoped lang="less">

</style>
